var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-cool-animated",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"circle1"}),_c('span',{staticClass:"circle2"}),_c('span',{staticClass:"circle3"}),_c('span',{staticClass:"circle4"}),_c('span',{staticClass:"circle5"}),_c('span',{staticClass:"text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }